import _ from "lodash";
import client from "lib/apolloClient/client";
import { cache } from "lib/apolloClient";

import { courseFragment } from "./CourseFragments";
import {
  getGradeDetailsQuery,
  getCourseCollaboratorQuery,
  getCourseStudentsFoldersQuery,
  getCourseGenericFoldersQuery,
  getCourseDetailsQuery,
  getMultiCourseStudentsFoldersQuery,
  getOrganizationCoursesStudents,
  getCourseSubjectDetailsQuery,
  getSubjectCoursesQuery,
  getUserCoursesV2Query,
  getUserCoursesQuery,
  getCourseExtraDetailsQuery,
  getUserCourseAccessQuery,
} from "./CourseQuery";

export const getGradesDetailsFromCache = grades => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradeDetailsQuery,
      variables: {
        ids: grades,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "multiNode", []);
  else return {};
};

export const getCourseStudentsFoldersFromCache = ({ id, folderType }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStudentsFoldersQuery,
      variables: {
        id,
        folderType,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", []);
  else return {};
};

export const getMultiCourseStudentsFoldersFromCache = ({ ids, folderType }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getMultiCourseStudentsFoldersQuery,
      variables: {
        ids,
        folderType,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "multiNode", []);
  else return {};
};

export const getCourseDetailsFromCache = ({ id, courseGradeFilters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseDetailsQuery,
      variables: {
        id,
        courseGradeFilters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", []);
  else return {};
};

export const uniqlyCombineGradeDetails = gradeList => {
  return _.reduce(
    gradeList,
    (result, grade) => {
      result["id"] = [...(result["id"] || []), grade.id];
      result["name"] = [...(result["name"] || []), grade.name];
      result["subjects"] = _.unionBy(
        result["subjects"],
        grade["subjects"],
        "id"
      );
      result["atlCategories"] = _.unionBy(
        result["atlCategories"],
        grade["atlCategories"],
        "id"
      );
      result["plannerTemplates"] = _.unionBy(
        result["plannerTemplates"],
        grade["plannerTemplates"],
        "id"
      );

      return result;
    },
    {}
  );
};

export const getUniqlyCombinedGradesDetails = grades => {
  const gradeList = getGradesDetailsFromCache(grades);
  return uniqlyCombineGradeDetails(gradeList);
};

export const getCourseFeedDetailsFromCache = ({
  courseId,
  courseGradeFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Course:${courseId}`,
      fragment: courseFragment.courseFeed,
      fragmentName: "courseFeedItem",
      variables: {
        courseGradeFilters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationCoursesStudentsFromCache = ({
  searchText,
  grades,
  organizationId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationCoursesStudents,
      variables: { searchText, grades, organizationId },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseCollaboratorsFromCache = course_id => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseCollaboratorQuery,
      variables: {
        id: course_id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseGenericFoldersFromCache = ({
  courseId,
  folderType,
  filters,
  assignmentFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseGenericFoldersQuery,
      variables: {
        courseId,
        folderType,
        filters,
        assignmentFilters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeCourseGenericFoldersInCache = ({
  courseId,
  data,
  folderType,
}) => {
  try {
    client.writeFragment({
      id: `Course:${courseId}`,
      fragment: courseFragment.courseGenericFoldersDetailsFragment,
      fragmentName: "courseItem",
      variables: {
        folderType,
      },
      data,
    });
  } catch (e) {}
};

export const getCourseExtraDetailsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseExtraDetailsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseSubjectDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseSubjectDetailsQuery,
      variables,
    });
  } catch (error) {
    return {};
  }

  return queryData != null ? _.get(queryData, "node", {}) : {};
};

export const getSubjectCoursesQueryFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectCoursesQuery,
      variables,
    });
  } catch (error) {
    return {};
  }

  return queryData != null ? _.get(queryData, "node", {}) : {};
};

export const getUserCoursesV2FromCache = ({
  userId,
  first,
  courseFilters,
  courseGradeFilters,
  archivedCourseFilters,
  projectGroupFilters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getUserCoursesV2Query,
      variables: {
        userId,
        first,
        courseFilters,
        courseGradeFilters,
        archivedCourseFilters,
        projectGroupFilters,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getUserCoursesFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getUserCoursesQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const updateCourseBookmarkStatusInCache = ({ courseId, isBookmark }) => {
  cache.updateFragment(
    {
      id: `Course:${courseId}`,
      fragment: courseFragment.courseBookmarkDetailsFragment,
      fragmentName: "courseBookmarkDetailsItem",
    },
    data => ({
      ...data,
      isBookmark,
    })
  );
};

export const getUserCourseAccessQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getUserCourseAccessQuery,
      variables,
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
